import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import queryString from 'query-string';

import PageLayout from '../../layouts/PageLayout';
import SplitLayout from '../../layouts/SplitLayout';
import UserBonusMonthWrapper from './containers/UserBonusMonthWrapper';
import FilterAllUsersMonthBonusPanel from './containers/FilterAllUsersMonthBonusPanel';
import { setSupervisorId, setBonusMonth, setUserId } from './actions';
import { getUser } from '../authentication/selectors';

import { routerProps } from '../../propTypes';

const propTypes = exact({
  setBonusMonthAction: PropTypes.func.isRequired,
  setSupervisorIdAction: PropTypes.func.isRequired,
  setUserIdAction: PropTypes.func.isRequired,
  currentlyLoggedInUser: PropTypes.object.isRequired,
  ...routerProps,
});

const BonusApprovalsPage = (props) => {
  return (
    <div>
      <PageLayout
        title="Bonus Approvals"
        render={() => {
          return (
            <SplitLayout
              leftSize={2}
              leftRender={() => { return <FilterAllUsersMonthBonusPanel />; }}
              rightSize={10}
              rightRender={() => { return <UserBonusMonthWrapper />; }}
            />
          );
        }}
      />
    </div>
  );
};


BonusApprovalsPage.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    currentlyLoggedInUser: getUser(state),
  };
};
const mapDispatchToProps = {
  setBonusMonthAction: setBonusMonth,
  setSupervisorIdAction: setSupervisorId,
  setUserIdAction: setUserId,
};

const withInitPage = lifecycle({
  componentWillMount() {
    const {
      location,
      setSupervisorIdAction,
      setBonusMonthAction,
      setUserIdAction,
      currentlyLoggedInUser,
    } = this.props;

    const querySringObject = queryString.parse(location.search);

    const { userId, bonusMonth, supervisorId } = querySringObject;

    /* Supervisor needs to go before user due to rule in reducer
    * Selecting supervisor clears out userId. Example switching supervisors */
    const supervisorIdValue = parseInt(supervisorId, 10);
    if (supervisorId && !Number.isNaN(supervisorIdValue)) {
      setSupervisorIdAction(supervisorIdValue);
    } else {
      setSupervisorIdAction(currentlyLoggedInUser.id);
    }

    const userIdValue = parseInt(userId, 10);
    if (userId && !Number.isNaN(userIdValue)) {
      setUserIdAction(userIdValue);
    }

    if (bonusMonth) {
      setBonusMonthAction(bonusMonth);
    }
  },
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withInitPage,
);


export default enhance(BonusApprovalsPage);
